import React, { Fragment } from 'react'
import { array, bool, string } from 'prop-types'
import { EMPTY_ARRAY } from '../../../utils/constants'
import AdLink from '../ad-link/AdLink'

const comma = <>, {' '} </>

const formatLinkUrl = (item, sitePath, itemPath) => (
  `/search${sitePath}/professionals/${item}/${itemPath}?ad_medium=search_result_professionals`
)

const getLinkPath = (item, itemData, site) => {
  const sitePath = site === 'us' ? '' : `/${site}`
  const defaultUrl = itemData.url + '?ad_source=search&ad_medium=search_result_professionals' || ''
  switch (item) {
    case 'expertise':
      return itemData.active ? formatLinkUrl(item, sitePath, itemData.path) : ''
    case 'categories':
    case 'country':
      return formatLinkUrl(item, sitePath, itemData.slug)
    default:
      return defaultUrl
  }
}

const SpecListItem = ({ items = EMPTY_ARRAY, item, isStringItem, landingUrl = '', site }) => {
  const containerClasses = ''
  const remainingItems = items.length > 3 ? items.length - 3 : 0
  const itemsToShow = items.slice(0, 3)
  const itemsList = itemsToShow.map((itemData = {}, index) => {
    const { name } = itemData
    const showComma = index > 0 ? comma : null
    const key = name + index
    const url = getLinkPath(item, itemData, site)
    return url
      ? (
        <Fragment key={key}>
          {showComma}
          <AdLink href={url}>{name}</AdLink>
        </Fragment>
      )
      : (
        <span key={key}>
          {showComma}
          {name}
        </span>
      )
  })
  return (
    <>
      <span className={containerClasses}>
        {itemsList}
      </span>
      {!!remainingItems && (
        <>
          {comma}
          {isStringItem
            ? <span>+{remainingItems}</span>
            : <AdLink href={landingUrl}>+{remainingItems}</AdLink>
          }
        </>
      )}
    </>
  )
}

SpecListItem.propTypes = {
  items: array,
  item: string,
  site: string,
  landingUrl: string,
  isStringItem: bool
}

export default SpecListItem